module.exports = __webpack_public_path__ + "static/media/confetti.b99491c6.webp";